import React from 'react';
import {View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {getTransportCardPaymentHistory} from '../../redux/actions/transportCard/cardPaymentHistory';
import {transportCardPaymentHistorySelector} from '../../redux/selectors/transportCard';
import {holderProfileSelector} from '../../redux/selectors/profile';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {LoadableContent} from '../../shared/components/loadableContent';
import {ResponsiveView} from '../../shared/components/responsiveView';
import Screen from '../../shared/components/screen';
import {CustomScrollView} from '../../shared/components/scrollView';
import {Text} from '../../shared/components/text';
import {useStyles} from '../../shared/hooks/styles';
import {useIsDesktop} from '../../shared/hooks/useIsDesktop';
import {Routes, Screens} from '../../shared/routing';
import {DeviceSize} from '../../shared/theme/helpers';
import {DesktopView} from './components/desktopView';
import {MobileView} from './components/mobileView';

const routes = [
  {
    title: 'Возможности карты',
    routeName: Screens.CardServices,
    webRoute: Routes.cardService,
  },
  {
    title: 'Транспортное приложение',
    routeName: Screens.TransportService,
    webRoute: Routes.transportService,
  },
  {
    title: 'История пополнений транспортной карты',
    routeName: Screens.TransportCardReplenishmentHistory,
    webRoute: Routes.transportCardReplenishmentHistory,
  },
];

export const TransportCardReplenishmentHistoryScreen: React.FC = () => {
  const holderProfile = useSelector(holderProfileSelector());
  const data = useSelector(transportCardPaymentHistorySelector);
  const isLoaded = useSelector(transportCardPaymentHistorySelector);
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const styles = useStyles(({theme, deviceSize, mediaOnly}) => {
    return {
      screen: {
        backgroundColor: theme.screen.container[deviceSize].backgroundColor,
      },
      sectionTitle: {
        marginTop: 38,
        marginBottom: 32,
      },
      sectionContainer: {
        overflow: 'hidden',
        marginTop: 30,
        ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 24}, {paddingHorizontal: 16}),
      },
      contentContainer: {
        paddingBottom: theme.screen.bottomOffset,
      },
    };
  });

  React.useEffect(() => {
    if (!holderProfile?.usc) {
      return;
    }

    dispatch(getTransportCardPaymentHistory(Number(holderProfile?.usc)));
  }, [holderProfile?.usc]);

  return (
    <Screen style={styles.screen}>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <Breadcrumbs style={{flex: undefined}} routes={routes} />
          <ResponsiveView only={[DeviceSize.desktop]}>
            <Text testID='transport-app-id' type='h2' style={styles.sectionTitle}>
              История пополнений транспортной карты
            </Text>
          </ResponsiveView>
          <LoadableContent style={styles.contentContainer} loading={!isLoaded}>
            {isDesktop ? <DesktopView list={data} /> : <MobileView list={data} />}
          </LoadableContent>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
